/* global axios */
import ApiClient from '../ApiClient';

class BrowserWhatsapp extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getSession(inboxId) {
    return axios.get(`${this.url}/${inboxId}/browser_whatsapp_session`);
  }

  performAction(inboxId, sessionAction) {
    return axios.post(
      `${this.url}/${inboxId}/browser_whatsapp_session/perform_action`,
      {
        session_action: sessionAction,
      }
    );
  }
}

export default new BrowserWhatsapp();
